module.exports = __webpack_public_path__ + "img/titanhq-logo.cca5981a.svg";